import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ModeProvider } from "./contexts/ModeContext";
import { LangProvider } from "./contexts/LangContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from 'sonner';

// Pages
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import Hafizlik from "./pages/Hafizlik";
import HafizlikReader from "./pages/HafizlikReader";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/legal/PrivacyPolicy";
import TermsOfService from "./pages/legal/TermsOfService";
import CookiePolicy from "./pages/legal/CookiePolicy";
import CookieConsent from "./components/CookieConsent";
import OnlineFriends from "./pages/Friends";
import ReadQuran from "./pages/ReadQuran";
import ListenQuran from "./pages/ListenQuran";
import Hatim from "./pages/Hatim";
import {
  SpecialPrayersFull,
  SunnetlerFull,
  HadithsFull,
  KidHadithsFull,
  ReligiousDaysFull,
  GamesExercisesFull,
  YearlyEventsFull,
} from "./pages/ContentPagesFull";
import Practice from "./pages/Practice";
import Statistics from "./pages/Statistics";
import Settings from "./pages/Settings";
import Badges from "./pages/Badges";
import Challenges from "./pages/Challenges";
import Social from "./pages/Social";
import ElifBa from "./pages/ElifBaNew";
import ElifBaOld from "./pages/ElifBa";
import LetterDetail from "./pages/LetterDetail";
import ModuleDetail from "./pages/ModuleDetail";
import ElifBaGames from "./pages/ElifBaGames";
import VoiceProgress from "./pages/VoiceProgress";
import Admin from "./pages/Admin";

function App() {
  useEffect(() => {
    // Service worker REMOVED — was serving stale cache and breaking deploys.
    // Proactively unregister any existing SW on returning users' devices,
    // and purge its caches, so they immediately get the freshest assets.
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((r) => r.unregister().catch(() => {}));
      }).catch(() => {});
    }
    if (window.caches && caches.keys) {
      caches.keys().then((keys) => {
        keys.forEach((k) => caches.delete(k).catch(() => {}));
      }).catch(() => {});
    }
  }, []);

  return (
    <ModeProvider>
      <LangProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/gizlilik-politikasi" element={<PrivacyPolicy />} />
            <Route path="/kullanim-kosullari" element={<TermsOfService />} />
            <Route path="/cerez-politikasi" element={<CookiePolicy />} />
            <Route path="/iletisim" element={<Contact />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hafizlik"
              element={
                <ProtectedRoute>
                  <Hafizlik />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hafizlik/sayfa/:pageNumber"
              element={
                <ProtectedRoute>
                  <HafizlikReader />
                </ProtectedRoute>
              }
            />
            <Route
              path="/oku"
              element={<ReadQuran />}
            />
            <Route
              path="/oku/page/:pageNumber"
              element={<ReadQuran />}
            />
            <Route
              path="/oku/:surahNumber"
              element={<ReadQuran />}
            />
            <Route
              path="/dinle"
              element={<ListenQuran />}
            />
            <Route
              path="/dinle/:surahNumber"
              element={<ListenQuran />}
            />
            <Route
              path="/hatim"
              element={
                <ProtectedRoute>
                  <Hatim />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dini-gunler"
              element={
                <ProtectedRoute>
                  <ReligiousDaysFull />
                </ProtectedRoute>
              }
            />
            <Route
              path="/yillik"
              element={
                <ProtectedRoute>
                  <ReligiousDaysFull />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dualar"
              element={
                <ProtectedRoute>
                  <SpecialPrayersFull />
                </ProtectedRoute>
              }
            />
            <Route
              path="/hadisler"
              element={
                <ProtectedRoute>
                  <HadithsFull />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sunnetler"
              element={
                <ProtectedRoute>
                  <SunnetlerFull />
                </ProtectedRoute>
              }
            />
            <Route
              path="/alistirmalar"
              element={
                <ProtectedRoute>
                  <GamesExercisesFull />
                </ProtectedRoute>
              }
            />
            <Route
              path="/arkadaslar"
              element={
                <ProtectedRoute>
                  <OnlineFriends />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cocuk-hadisleri"
              element={
                <ProtectedRoute>
                  <KidHadithsFull />
                </ProtectedRoute>
              }
            />
            <Route
              path="/dashboard-eski"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/practice"
              element={
                <ProtectedRoute>
                  <Practice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/elifba"
              element={
                <ProtectedRoute>
                  <ElifBa />
                </ProtectedRoute>
              }
            />
            <Route
              path="/elifba/:letterId"
              element={
                <ProtectedRoute>
                  <LetterDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/elifba/games"
              element={
                <ProtectedRoute>
                  <ElifBaGames />
                </ProtectedRoute>
              }
            />
            <Route
              path="/elifba/progress"
              element={
                <ProtectedRoute>
                  <VoiceProgress />
                </ProtectedRoute>
              }
            />
            <Route
              path="/elifba/m/:slug"
              element={
                <ProtectedRoute>
                  <ModuleDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/statistics"
              element={
                <ProtectedRoute>
                  <Statistics />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <Settings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/badges"
              element={
                <ProtectedRoute>
                  <Badges />
                </ProtectedRoute>
              }
            />
            <Route
              path="/challenges"
              element={
                <ProtectedRoute>
                  <Challenges />
                </ProtectedRoute>
              }
            />
            <Route
              path="/challenges/:challengeId"
              element={
                <ProtectedRoute>
                  <Challenges />
                </ProtectedRoute>
              }
            />
            <Route
              path="/social"
              element={
                <ProtectedRoute>
                  <Social />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
          </Routes>
          <CookieConsent />
        </div>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      </LangProvider>
    </ModeProvider>
  );
}

export default App;
